// The Tier Change Console (#222) drives real Stripe writes through the God-Admin
// billing orchestrator, so it must stay disabled on the production host until the
// #222 go-live is deliberately switched on. Fail-closed: the console is available
// only on the known non-production moderation hosts (dev / staging / local), or when
// a build explicitly opts in via VITE_ENABLE_TIER_CHANGE_CONSOLE=true — the switch
// used to enable it on production at go-live without a code change.
const NON_PRODUCTION_HOSTS = new Set([
  'moderation-dev.pour.now',
  'moderation-staging.pour.now',
  'localhost',
  '127.0.0.1',
])

export const isTierChangeConsoleEnabled = (): boolean => {
  if (import.meta.env.VITE_ENABLE_TIER_CHANGE_CONSOLE === 'true') return true
  if (typeof window === 'undefined') return false
  return NON_PRODUCTION_HOSTS.has(window.location.hostname)
}
